// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2aFB6","emails":"CreateEditClinics_emails__3cKTH","emailTagLabel":"CreateEditClinics_emailTagLabel__2EW95"};